<template>
  <button class="text-link" @click="onClick">
    <slot />
  </button>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  href: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['click'])

const onClick = () => {
  if (props.href) {
    window.location.href = props.href
  } else {
    emit('click')
  }
}
</script>

<style lang="scss" scoped>
.text-link {
  @media (hover: hover) {
    &:hover {
      opacity: 0.7;
    }
  }

  font-size: 1.6rem;
  line-height: 1.6;
  color: $link;
  cursor: pointer;
  text-decoration: none;
}
</style>
